import { z } from 'zod';
import { baseMessageSchema, createMessageId } from './_base';
import {
  analysisCapabilitiesCommandSchema,
  analysisCapabilitiesReplySchema,
  analysisJobReplySchema,
  analysisStartCommandSchema,
  analysisPreviewCommandSchema,
  analysisRenewCommandSchema,
  analysisCancelCommandSchema,
  chunkReceiptSchema,
  leaseSchema,
} from '../types/api/macroCalibration';

export enum MacroAnalysisMessageType {
  CAPABILITIES = 'MACRO_ANALYSIS_CAPABILITIES',
  ASSIGN = 'MACRO_ANALYSIS_ASSIGN',
  PROGRESS = 'MACRO_ANALYSIS_PROGRESS',
  RESULT_CHUNK = 'MACRO_ANALYSIS_RESULT_CHUNK',
  ACK = 'MACRO_ANALYSIS_ACK',
  HEARTBEAT = 'MACRO_ANALYSIS_HEARTBEAT',
  RENEW = 'MACRO_ANALYSIS_RENEW',
  CANCEL = 'MACRO_ANALYSIS_CANCEL',
  COMPLETE = 'MACRO_ANALYSIS_COMPLETE',
}
const requestId = z.string().min(1).max(128);
const base = { requestId };
export const macroAnalysisMessageSchema = z.discriminatedUnion('type', [
  baseMessageSchema.extend({ ...base, type: z.literal(MacroAnalysisMessageType.CAPABILITIES),
    payload: z.union([analysisCapabilitiesCommandSchema, analysisCapabilitiesReplySchema]) }).strict(),
  baseMessageSchema.extend({ ...base, type: z.literal(MacroAnalysisMessageType.ASSIGN),
    command: z.union([analysisStartCommandSchema, analysisPreviewCommandSchema]) }).strict(),
  baseMessageSchema.extend({ ...base, type: z.literal(MacroAnalysisMessageType.PROGRESS), reply: analysisJobReplySchema }).strict(),
  baseMessageSchema.extend({ ...base, type: z.literal(MacroAnalysisMessageType.RESULT_CHUNK), reply: analysisJobReplySchema.refine(reply => !!reply.chunk) }).strict(),
  baseMessageSchema.extend({ ...base, type: z.literal(MacroAnalysisMessageType.ACK), lease: leaseSchema, receipt: chunkReceiptSchema }).strict(),
  baseMessageSchema.extend({ ...base, type: z.literal(MacroAnalysisMessageType.HEARTBEAT), lease: leaseSchema }).strict(),
  baseMessageSchema.extend({ ...base, type: z.literal(MacroAnalysisMessageType.RENEW), command: analysisRenewCommandSchema }).strict(),
  baseMessageSchema.extend({ ...base, type: z.literal(MacroAnalysisMessageType.CANCEL), command: analysisCancelCommandSchema }).strict(),
  baseMessageSchema.extend({ ...base, type: z.literal(MacroAnalysisMessageType.COMPLETE), reply: analysisJobReplySchema.refine(reply => reply.status === 'completed' && (!!reply.completion || !!reply.previewAsset)) }).strict(),
]);
export type MacroAnalysisMessage = z.infer<typeof macroAnalysisMessageSchema>;
type Payload<T> = T extends unknown ? Omit<T, 'id' | 'timestamp'> : never;
export function generateMacroAnalysisMessage(payload: Payload<MacroAnalysisMessage>): MacroAnalysisMessage {
  return macroAnalysisMessageSchema.parse({ id: createMessageId(), timestamp: Date.now(), ...payload });
}
